module.exports = __webpack_public_path__ + "static/media/procast-logo-small.f773da97.png";